import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCjfR9WIDdZK7DEUQeCDd6jHxcO1fQ7fn0",
    authDomain: "soucient-project-management.firebaseapp.com",
    projectId: "soucient-project-management",
    messagingSenderId: "337812802242",
    appId: "1:337812802242:web:8ad011a1d8b73dead9c95b",
    // Optional:
    // measurementId: "YOUR_MEASUREMENT_ID"
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };